import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import BvBtn from 'volta/components/bv-btn';
import BvPopover from 'volta/components/bv-popover';
import BvSelectMulti from 'volta/components/bv-select-multi';
import { TASK_TYPES } from 'volta/models/task';

import type { TOC } from '@ember/component/template-only';
import type { TTaskType } from 'volta/models/types/tasks';

export interface TasksKitFiltersSignature {
  Args: {
    taskTypes?: TTaskType[];
    onTaskFilterChange: (taskTypes: TTaskType[]) => void;
    filterOptions: TTaskType[];
  };
  Element: HTMLElement;
}

const getSelectedFilters = (taskTypes?: TTaskType[]) => {
  if (!taskTypes) {
    return [];
  }
  return TASK_TYPES.filter((type) => taskTypes.includes(type));
};

const TasksKitFiltersComponent: TOC<TasksKitFiltersSignature> = <template>
  {{#let (getSelectedFilters @taskTypes) as |selectedFilters|}}
    <BvPopover @horizontalPosition='right' @size='sm' @preventScroll={{false}} as |popover|>
      <BvBtn
        @iconRight='funnel-outline'
        @subtle={{true}}
        @color={{if selectedFilters.length 'primary'}}
        @text={{if selectedFilters.length selectedFilters.length}}
        @onClick={{popover.toggle}}
        {{popover.trigger}}
      />
      <popover.Content>
        <popover.Body>
          <BvSelectMulti
            @allowClear={{true}}
            @fill={{true}}
            @onChange={{@onTaskFilterChange}}
            @options={{@filterOptions}}
            @placeholder={{t 'tasksPage.title'}}
            @selected={{selectedFilters}}
            ...attributes
            as |filter|
          >
            {{t (concat 'tasksPage.types.' filter)}}
          </BvSelectMulti>
        </popover.Body>
      </popover.Content>
    </BvPopover>
  {{/let}}
</template>;

export default TasksKitFiltersComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::Filters': typeof TasksKitFiltersComponent;
    'tasks-kit/filters': typeof TasksKitFiltersComponent;
  }
}
